import React, { useState } from "react";
import { useDispatch } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@material-ui/core";

import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";


import { postNotasIntegracion } from "../../../../../actions/discapacidad/discapacidadActions";
import { TIPO_NOTA_SOLICITUD_INTEGRACION } from "../../../../../utils/constants";

const TIPOS_NOTA = [
  {descripcion:"PUBLICA", idTipoNota:3},
  {descripcion:"PRIVADA", idTipoNota:4},

]
export const ModalNotasIntegracion = (props) => {
  const dispatch = useDispatch();

  const [idTipoNota, setIdTipoNota] = useState(
    !!props.nota ? props.nota.idTipoNota : ""
  );
  const [descripcion, setDescripcion] = useState(
    !!props.nota ? props.nota.descripcion : ""
  );
  const [error, setError] = useState(false);

  const onChangeTextAreaHandler = (e) => {
    const hayError =
      e?.target?.value?.length === 0 || e?.target?.value?.length === 500;
    setError(hayError);
    if (!hayError) {
      setDescripcion(e.target.value);
    }
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();

    let nota = null;
    
    if (!props.nota) {
      nota = {
        idSolicitud: props.idSolicitud,
        idTipoNota: (props.idTipoNota ? props.idTipoNota : idTipoNota),
        descripcion,
      };
    } else {
      nota = {
        idNota: props.nota?.idNota,
        descripcion,
      };
    }

    const method = !props.nota ? "POST" : "PUT";

    dispatch(postNotasIntegracion(nota, props.idSolicitud, method, props.close, props.tipoNotaDisabled,
      props.idEstadoSolicitud, props.closeModalAuditar));
    if (props.privada === true) {
      props.guardar();
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        <ValidatorForm onSubmit={onSubmitHandler}>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={1} md={2} lg={3} />
            <Grid item xs={10} sm={10} md={8} lg={6}>
              {Array.isArray(TIPOS_NOTA) && props.idTipoNota !== TIPO_NOTA_SOLICITUD_INTEGRACION.RECHAZO && props.idTipoNota !== TIPO_NOTA_SOLICITUD_INTEGRACION.DEVOLUCION && (
                <SelectValidator
                  fullWidth
                  label="Tipo de Nota"
                  name="idTipoNota"
                  value={props.tipoNotaDisabled ? 3 : idTipoNota}
                  disabled={!!props.nota || props.tipoNotaDisabled}
                  onChange={(e) => setIdTipoNota(e.target.value)}
                  validators={["required"]}
                  errorMessages={["Este campo es requerido"]}
                >
                  {TIPOS_NOTA.map((tipoNota)=>(
                        <MenuItem key={tipoNota.idTipoNota} value={tipoNota.idTipoNota}>
                          {tipoNota.descripcion}
                        </MenuItem>
                    ))}
                </SelectValidator>
              )}
            </Grid>
            <Grid item xs={1} sm={1} md={2} lg={3} />
          </Grid>
          <Grid container spacing={2} style={{ margin: "2rem 0" }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                rows={4}
                label="Nota"
                name="descripcion"
                value={descripcion}
                disabled={
                  props.desdeIngresoSolicitud && props.titulo !== "Agregar Nota"
                }
                onChange={onChangeTextAreaHandler}
                error={error}
                helperText={error && "Este campo es requerido"}
              />
            </Grid>
          </Grid>
          <div
            style={{
              margin: "1rem 0",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
            }}
          >
            <Button variant="contained" color="primary" onClick={props.close}>
              Cancelar
            </Button>
            <Button type="submit" variant="contained" disabled={props.disabled} color="primary">
              Guardar
            </Button>
          </div>
        </ValidatorForm>
      </DialogContent>
    </Dialog>
  );
};
